import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import SectionView from "../../../layout/section/SectionView";
import BillOfMaterialsAssetFormComponent from "./assetForm/BillOfMaterialsAssetFormComponent";
import {BomItem} from "../../../../model/job/BomItems";

interface IComponentProps {
	/**
	 * On cancel button click.
	 */
	closeModal: () => void;
	/**
	 * Bill of materials id
	 */
	bomDetailsId: string;
	/**
	 * Bill of materials asset object
	 */
	bomAsset: BomItem;
	/**
	 * Job id
	 */
	jobId: string;
}

export default class EditAssetModal extends React.Component<IComponentProps> {
	render() {
		return (
			<Modal onCloseClicked={this.props.closeModal} title={'Edit asset'}>
				<SectionView>
					<BillOfMaterialsAssetFormComponent bomAsset={this.props.bomAsset}
													   bomDetailsId={this.props.bomDetailsId}
													   onCancel={this.props.closeModal}
													   onSuccess={this.props.closeModal}
													   jobId={this.props.jobId}/>
				</SectionView>
			</Modal>
		);
	}
}